import {
  RequestUtil,
  gtmPushTagManager,
} from 'pmt-common';

import { showErrorMessage } from '../common/messageBox/actions';

/**
 * Action for session keeper
 */
import {
  SET_LAST_TIME_INTERACT_UI,
  PING_SERVER_START,
  PING_SERVER_SUCCESS,
  PING_SERVER_FAILURE,
  IS_CATI_SESSION_ACTIVE_FAILURE,
  IS_CATI_SESSION_ACTIVE_START,
  IS_CATI_SESSION_ACTIVE_SUCCESS,
  END_CATI_ACTIVE_SESSION_START,
  END_CATI_ACTIVE_SESSION_FAILURE,
  END_CATI_ACTIVE_SESSION_SUCCESS,
  END_CATI_PROCESS_START,
  END_CATI_PROCESS_SUCCESS,
  END_CATI_PROCESS_FAILURE,
  GET_LIST_SURVEYS_START,
  GET_LIST_SURVEYS_SUCCESS,
  GET_LIST_SURVEYS_FAILURE,
} from './events';
// import api from constants
import {
  API_PING_SERVER,
  API_CATI_SESSION,
  API_UPDATE_TOKEN,
  API_END_CATI_SESSION,
  GET_LIST_SURVEYS,
} from '../../constants';

/**
 * Set last time user interact UI
 * @return Object
 */
export const setLastTimeInteractUI = time => ({
  type: SET_LAST_TIME_INTERACT_UI,
  time,
});

/**
 * Ping server start
 * @return Object
 */
export const pingServerStart = () => ({
  type: PING_SERVER_START,
});
/**
 * Ping server success
 * @param {Object} response
 * @return Object
 */
export const pingServerSuccess = response => ({
  type: PING_SERVER_SUCCESS,
  response,
});
/**
 * Ping server failure
 * @param {Object} error
 * @return Object
 */
export const pingServerFailure = error => ({
  type: PING_SERVER_FAILURE,
  error,
});

/**
 * Sync Keycloak tokens to the Spring session on the backend.
 * @param {{ accessToken?: string, idToken?: string, refreshToken?: string }} [tokens]
 * @return {Promise}
 */
export const updateTokenOnServer = (tokens = {}) => async () => {
  const accessToken = tokens.accessToken || (window.keycloakAuth && window.keycloakAuth.token);
  const idToken = tokens.idToken || (window.keycloakAuth && window.keycloakAuth.idToken);
  const refreshToken = tokens.refreshToken || (window.keycloakAuth &&
    window.keycloakAuth.refreshToken);

  if (!accessToken) {
    return null;
  }

  try {
    const response = await window.fetch(API_UPDATE_TOKEN, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
      },
      credentials: 'include',
      body: JSON.stringify({
        accessToken,
        idToken,
        refreshToken,
      }),
    }, false).then((res) => {
      if (res.status >= 400) {
        throw new Error('updateToken failed');
      }
      return res.json ? res.json() : res;
    });
    return response;
  } catch (e) {
    return e;
  }
};

/**
 * Ping server
 * @return {Promise}
 */
export const pingServer = async () =>
  async (dispatch) => {
    try {
      dispatch(pingServerStart());
      const response = await window.fetch(API_PING_SERVER, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
        },
        credentials: 'include',
      }).then((res) => {
        if (res.status >= 400) {
          throw new Error(res.json());
        }
        return res.json();
      });
      if (!response.Status) {
        window.localStorage.setItem('activeCatiSession', false);
      }
      // Success
      dispatch(pingServerSuccess(response));
      return response;
    } catch (e) {
      // Dispatch to failure
      dispatch(pingServerFailure(e));
      return e;
    }
  };

/**
 * Get CATI Session status start
 * @return Object
 */
export const getCatiSessionStart = () => ({
  type: IS_CATI_SESSION_ACTIVE_START,
  time: Date.now(),
});
/**
 * Get CATI Session status success
 * @param {Object} response
 * @return Object
 */
export const getCatiSessionSuccess = response => ({
  type: IS_CATI_SESSION_ACTIVE_SUCCESS,
  response,
});
/**
 * Get CATI Session status failure
 * @param {Object} error
 * @return Object
 */
export const getCatiSessionFailure = error => ({
  type: IS_CATI_SESSION_ACTIVE_FAILURE,
  error,
});

/** Get CATI Session status
 *
 * @return {Promise}
 */
export const getCatiSession = async () =>
  async (dispatch) => {
    try {
      dispatch(getCatiSessionStart());
      const response = await window.fetch(API_CATI_SESSION, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
        },
        credentials: 'include',
      }).then((res) => {
        if (res.status >= 400) {
          throw new Error(res.json());
        }
        return res.json();
      });
      if (!response.Status) {
        window.localStorage.setItem('activeCatiSession', false);
        window.localStorage.removeItem('CurrentActiveSessionId');
        window.localStorage.removeItem('ImpersonatedParticipant');
        window.localStorage.removeItem('participantKeycloakRealm');
      }
      // Success
      dispatch(getCatiSessionSuccess(response));
    } catch (e) {
      // Dispatch to failure
      dispatch(getCatiSessionFailure(e));
    }
  };

// GET_LIST_SURVEYS
export const getListSurveysStart = () => ({
  type: GET_LIST_SURVEYS_START,
});

export const getListSurveysSuccess = response => ({
  type: GET_LIST_SURVEYS_SUCCESS,
  response,
});

export const getListSurveysFailure = error => ({
  type: GET_LIST_SURVEYS_FAILURE,
  error,
});

export const getListSurveys = participantId => async (dispatch) => {
  try {
    dispatch(getListSurveysStart());
    const url = GET_LIST_SURVEYS;
    const options = {
      params: {
        participantId,
      },
    };
    const response = await RequestUtil.getData(url, options);
    dispatch(getListSurveysSuccess(response));
  } catch (e) {
    dispatch(getListSurveysFailure(e));
  }
};

export const endCATIProcessSuccess = response => ({
  type: END_CATI_PROCESS_SUCCESS,
  response,
});

export const endCATIProcessFailure = error => ({
  type: END_CATI_PROCESS_FAILURE,
  error,
});
export const endCATIProcessStart = () => ({
  type: END_CATI_PROCESS_START,
});

export const endCATIProcess = (sessionId, platformParticipantId, endType, participantId) =>
  async (dispatch) => {
    try {
      dispatch(endCATIProcessStart());
      const url = API_END_CATI_SESSION;
      const data = {
        participantSessionId: sessionId,
        platformParticipantId,
        type: endType,
      };
      const response = await RequestUtil.postData(url, data);
      if (response.endSession) {
        window.localStorage.removeItem('CurrentActiveSessionId');
        window.localStorage.removeItem('ImpersonatedParticipant');
        window.localStorage.removeItem('participantKeycloakRealm');
        window.localStorage.setItem('activeCatiSession', false);
      }
      dispatch(endCATIProcessSuccess(response));
      dispatch(getListSurveys(participantId));
      const catiSessionStatus = `CATISession${endType === 'cancel' ? 'Cancelled' : 'Ended'}`;
      dispatch(gtmPushTagManager(catiSessionStatus));
      dispatch(getCatiSession());
    } catch (e) {
      dispatch(endCATIProcessFailure(e));
    }
  };

export const endCATIActiveSessionsSuccess = response => ({
  type: END_CATI_ACTIVE_SESSION_SUCCESS,
  response,
});

export const endCATIActiveSessionsFailure = error => ({
  type: END_CATI_ACTIVE_SESSION_FAILURE,
  error,
});

export const endCATIActiveSessionsStart = () => ({
  type: END_CATI_ACTIVE_SESSION_START,
});

export const endCATIActiveSessions = (url, token, programCode, sessionId,
  platformParticipantId, endType, participantId) =>
  async (dispatch) => {
    try {
      dispatch(endCATIActiveSessionsStart());
      const response = await window.fetch(`${url}&programCode=${programCode}`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
      }, true).then(res => res.json());
      if (response.success) {
        dispatch(endCATIProcess(sessionId, platformParticipantId, endType, participantId));
        dispatch(endCATIActiveSessionsSuccess(response));
      }
      return response;
    } catch (ex) {
      showErrorMessage(ex.message)(dispatch);
      dispatch(endCATIActiveSessionsFailure(ex));
    }
    return {};
  };

